import React, { Component } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './BaseLayout.scss';

class BaseLayout extends Component {
    render() {
        return (
            <div>
                <Header /> {/* redux connected */}                
                <div className="container-full p-y-lg bg-info-lighter">
                {process.env.WARNING=='True'?
                <div className="container-full p-t-0" >
                    <p>{process.env.WARNING_MESSAGE} <br/></p>                      
                </div> : <div/>}
                    {this.props.children}
                </div>
                {/* <Footer /> */} {/* Removed footer as need help button moved to header section  */}{/* redux connected */}
            </div>
        );
    }
}

export default BaseLayout;



// WEBPACK FOOTER //
// ./app/views/BaseLayout.jsx